import { ChronoIcon } from "@images/svgIcons/chronoIcon"
import { displayTotalTime, getTrainingChronoTitle } from "@modules/chrono/chronoUtils"
import { ExploreBenchmarkItemEntity } from "@modules/explore/entities/exploreEntity"
import { Text } from "@/components/ui/baseUi/text"

type ExploreCardFooterChronoProps = {
  item: ExploreBenchmarkItemEntity
} & React.ComponentProps<"div">

export function ExploreCardFooterChrono({ item, ...props }: ExploreCardFooterChronoProps) {
  return (
    <div className="flex w-fit items-center rounded-full bg-neutral-900/10 px-3 py-2 backdrop-blur-xs" {...props}>
      <ChronoIcon color="currentColor" className="mr-2 text-textOnSecondaryBg-body" />
      {item.chrono && (
        <Text fontStyle="LM">{`${getTrainingChronoTitle(item.chrono.type)} - ${displayTotalTime(item.chrono)}`}</Text>
      )}
    </div>
  )
}
